import React from 'react';
import PropTypes from 'prop-types';
import HalfFilledStar from '../../svgs/star-half-filled.svg';
import {HALF_STAR_SIZE_PROP_TYPE} from '../../constants/constants';

const DEFAULT_SIZE = 'small';

const HalfStarSvg = ({size}) => {
    let newSize = DEFAULT_SIZE;

    const sizeMap = {
        xsmall: '16',
        small: '24',
        medium: '48',
        large: '96',
        xlarge: '144',
    };

    if (size) {
        newSize = size;
    }

    return (
        <svg width={sizeMap[newSize]} height={sizeMap[newSize]}>       
            <image
                href={HalfFilledStar}
                src={HalfFilledStar}
                xlinkHref={HalfFilledStar}
                width={sizeMap[newSize]}
                height={sizeMap[newSize]}
            />    
        </svg>
    );
};

HalfStarSvg.propTypes = {
    size: PropTypes.oneOf(HALF_STAR_SIZE_PROP_TYPE),
};

export default HalfStarSvg;


// WEBPACK FOOTER //
// ./src/components/ratingStars/HalfStarSvg.js